







































































































































































import { Component, Mixins } from 'vue-property-decorator';
import DetailMixin from '@/mixins/DetailMixin';
import SendEmailDialog from '@/components/SendEmailDialog.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import FieldDefs from './FieldDefs';

@Component({
  components: {
    SendEmailDialog,
    ConfirmDialog
  }
})
export default class SalesDetail extends Mixins(DetailMixin) {
  public tableCfg = FieldDefs;
  public apiUrl = this.getTableCfg(this.tableCfg, 'apiUrl');

  public showSendAccounting() {
    if (!this.roleCheckAPI('sale', 'sendaccounting')) {
      return false;
    }
    const layout: any = this.$refs.layout;
    if (layout && layout.rec) {
      //  console.log('showSendAccounting', layout.rec.is_closed, layout.rec.is_locked);
       return !layout.rec.is_closed && !layout.rec.is_locked;
    } else {
      return false;
    }
  }

  public showSendMail() {
    if (!this.roleCheckAPI('sale', 'getmailtemplate')) {
      return false;
    }
    const layout: any = this.$refs.layout;
    if (layout && layout.rec) {
      //  console.log('showSendMail', layout.rec.is_closed, layout.rec.is_locked);
       return !layout.rec.is_locked;
    } else {
      return true;
    }
  }

  public emailWasSent(id) {
    const ref: any = this.$refs.layout;
    this.$set(ref.rec, 'is_locked', true);
  }
  public async sendAccounting(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/sendaccounting');
    this.$set(rec, 'is_locked', true);
  }
  public async resetAccounting(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/resetaccounting');
    this.$set(rec, 'sent_accounting', null);
  }

  public async recalculate(rec) {
    const response = await this.api.postAction(this.$store, this.getTableCfg(this.tableCfg, 'apiUrl') + String(rec.id) + '/recalculate');
    console.log(response);
    const ref: any = this.$refs.layout;
    ref.onUndoEdit();
  }




}
